import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPhysicalTarget } from '../processes.api';

const PHYSICAL_TARGET_QUERY_KEY = ['processes', 'physical-target'] as const;

/** Server-state voor het fysieke doelbeeld (R2), per klant — de keten als data-gedreven ladder. */
export function usePhysicalTarget(gln?: string) {
  return useQuery({
    // De klant in de sleutel: anders toont een andere klant het gecachte antwoord van de vorige.
    queryKey: [...PHYSICAL_TARGET_QUERY_KEY, gln ?? null],
    queryFn: () => getPhysicalTarget({ gln }),
    staleTime: 30 * 1000,
  });
}

/**
 * Handmatige ververs-actie (UXR9): het doelbeeld legt zelf de gedeelde set lopende orders leeg. Die set
 * voedt ook de tegel en de productenlijst, dus alle Processen-queries herladen, niet alleen het doelbeeld.
 */
export function useRefreshPhysicalTarget(gln?: string) {
  const queryClient = useQueryClient();
  return async () => {
    await getPhysicalTarget({ gln, refresh: true });
    await queryClient.invalidateQueries({ queryKey: ['processes'] });
  };
}
